module.exports = __webpack_public_path__ + "static/media/Berry.e6065886.jpg";